/**
 * Relevant columns only (not full API row dump).
 * Keys are tried in order; first existing value on row wins for legacy aliases.
 */

import {
  freightOrderStatusBadgeCell,
  freightOrderTypeBadgeCell
} from "../components/admin/freightOrderColumnCells";
import {
  freightFormRequestQtyCell,
  freightFormRequestTypeBadgeCell
} from "../components/admin/freightFormRequestColumnCells";

export const FREIGHT_ACTIVE_USER_COLUMNS = [
  { key: "code", label: "Code", aliases: ["user_code"], defaultVisible: true },
  { key: "name", label: "Name", aliases: [], defaultVisible: true },
  { key: "company_name", label: "Company", aliases: [], defaultVisible: true },
  { key: "mobile_no", label: "Mobile", aliases: ["mobile"], defaultVisible: true },
  { key: "email", label: "Email", aliases: [], defaultVisible: true },
  { key: "gst", label: "GST", aliases: [], defaultVisible: true },
  { key: "eway_trans_id", label: "Transport ID", aliases: ["transport_id"], defaultVisible: true },
  { key: "city_name", label: "City", aliases: ["city"], defaultVisible: true },
  { key: "state_name", label: "State", aliases: ["state"], defaultVisible: true },
  { key: "rm_name", label: "RM", aliases: [], defaultVisible: true },
  { key: "status", label: "Status", aliases: [], defaultVisible: false },
  {
    key: "registration",
    label: "Registered",
    aliases: [],
    defaultVisible: true,
    html: true
  },
  {
    key: "doc_approve_column",
    label: "Documents",
    aliases: ["doc_approve_name"],
    defaultVisible: true,
    html: true
  }
];

export const FREIGHT_NEW_USER_COLUMNS = [
  { key: "code", label: "Code", aliases: ["user_code"], defaultVisible: true },
  { key: "name", label: "Name", aliases: [], defaultVisible: true },
  { key: "company_name", label: "Company", aliases: [], defaultVisible: true },
  { key: "mobile_no", label: "Mobile", aliases: ["mobile"], defaultVisible: true },
  { key: "email", label: "Email", aliases: [], defaultVisible: false },
  { key: "gst", label: "GST", aliases: [], defaultVisible: true },
  { key: "rm_name", label: "RM", aliases: [], defaultVisible: true },
  { key: "area_name", label: "Area", aliases: [], defaultVisible: true },
  { key: "approve_by_name", label: "Approver", aliases: [], defaultVisible: false },
  { key: "is_verify", label: "Verify", aliases: [], defaultVisible: false }
];

/** Freight buyer/seller form requests (`/freightFormRequest/data` DataTables). */
export const FREIGHT_FORM_REQUEST_COLUMNS = [
  { key: "id", label: "ID", aliases: [], defaultVisible: false },
  {
    key: "type",
    label: "Type",
    aliases: ["row_type"],
    defaultVisible: true,
    sortable: false,
    renderCell: freightFormRequestTypeBadgeCell
  },
  { key: "rm_name", label: "RM", aliases: [], defaultVisible: true },
  { key: "rm_mobile_no", label: "RM mobile", aliases: [], defaultVisible: false },
  { key: "master_name", label: "Master / company", aliases: [], defaultVisible: true },
  { key: "master_code", label: "Master code", aliases: [], defaultVisible: false },
  { key: "normal_name", label: "Contact name", aliases: [], defaultVisible: true },
  { key: "user_mobile_no", label: "User mobile", aliases: [], defaultVisible: true },
  { key: "from_location", label: "From", aliases: [], defaultVisible: true },
  { key: "to_location", label: "To", aliases: [], defaultVisible: true },
  {
    key: "qty",
    label: "Qty",
    aliases: [],
    defaultVisible: true,
    renderCell: freightFormRequestQtyCell
  },
  { key: "loading_date", label: "Loading date", aliases: [], defaultVisible: true },
  { key: "material_type_name", label: "Material", aliases: [], defaultVisible: true },
  { key: "remarks", label: "Remarks", aliases: [], defaultVisible: true },
  { key: "created_at", label: "Submitted", aliases: [], defaultVisible: true }
];

/** Freight orders index (`/freightOrder/index`). `key` doubles as `sort_by` when supported by the API. */
export const FREIGHT_ORDER_COLUMNS = [
  { key: "auto_id", label: "Order ID", aliases: [], defaultVisible: true },
  { key: "order_name", label: "Name", aliases: [], defaultVisible: true },
  {
    key: "order_type",
    label: "Type",
    aliases: ["order_type_name"],
    defaultVisible: true,
    sortable: false,
    renderCell: freightOrderTypeBadgeCell
  },
  {
    key: "order_status",
    label: "Status",
    aliases: ["order_status_name"],
    defaultVisible: true,
    sortable: false,
    renderCell: freightOrderStatusBadgeCell
  },
  { key: "load_qty", label: "Load (MT)", aliases: [], defaultVisible: true },
  { key: "from_area_name", label: "From area", aliases: [], defaultVisible: true },
  { key: "from_city_name", label: "From city", aliases: [], defaultVisible: false },
  { key: "to_area_name", label: "To area", aliases: [], defaultVisible: true },
  { key: "to_city_name", label: "To city", aliases: [], defaultVisible: false },
  { key: "grade_name", label: "Grade", aliases: [], defaultVisible: true },
  { key: "processes_name", label: "Process", aliases: [], defaultVisible: false },
  { key: "brands_name", label: "Brand", aliases: [], defaultVisible: false },
  { key: "grade_code_name", label: "Grade code", aliases: [], defaultVisible: false },
  {
    key: "freight_order_detail_price",
    label: "Price (sum)",
    aliases: [],
    defaultVisible: true
  },
  { key: "detail_count", label: "Quotes", aliases: [], defaultVisible: true },
  { key: "enquiry_person_name", label: "Enquiry by", aliases: [], defaultVisible: false },
  { key: "rm_name", label: "RM", aliases: [], defaultVisible: false },
  { key: "created_at", label: "Created", aliases: [], defaultVisible: true }
];

export const FREIGHT_INACTIVE_USER_COLUMNS = [
  { key: "code", label: "Code", aliases: ["user_code"], defaultVisible: true },
  { key: "name", label: "Name", aliases: [], defaultVisible: true },
  { key: "company_name", label: "Company", aliases: [], defaultVisible: true },
  { key: "mobile_no", label: "Mobile", aliases: ["mobile"], defaultVisible: true },
  { key: "email", label: "Email", aliases: [], defaultVisible: true },
  { key: "gst", label: "GST", aliases: [], defaultVisible: false },
  { key: "city_name", label: "City", aliases: ["city"], defaultVisible: true },
  { key: "state_name", label: "State", aliases: ["state"], defaultVisible: true },
  { key: "rm_name", label: "RM", aliases: [], defaultVisible: true }
];

export { pickRowValue, rowSearchText } from "../utils/tableColumnValue";
